import React from 'react';

export function AccessGranted() {
  return (
    <div className="flex flex-col items-center justify-center space-y-4 p-6">
      <div className="flex items-center justify-center w-12 h-12 rounded-full bg-green-100 text-green-600">
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
        </svg>
      </div>
      
      <div className="text-center space-y-2">
        <h3 className="text-lg font-semibold text-gray-900">Access Granted</h3>
        <p className="text-sm text-gray-600">
          You have access to the requested spreadsheet
        </p>
        <p className="text-xs text-gray-500">
          You can now close this tab and return to your work
        </p>
      </div>
    </div>
  );
} 